import { useQuery } from 'react-query';
import { QUERY_KEYS } from '../../../common/constants/queryKeys.constant';
import { getAdminInfo } from '../service';

export function useGetAdminInfo() {
  return {
    ...useQuery([QUERY_KEYS.ADMIN_INFO], getAdminInfo, {
      cacheTime: 0,
    }),
  };
}
